import React from "react";

const Subheading=({title,orangetext,orangeEndtext,content, ...restProps})=>{
    return(
        <>
           <h4 style={{fontWeight:"500"}} {...restProps} ><span style={{color:"#c82e21"}}>{orangetext}</span>{title}<span style={{color:"#c82e21"}}>{orangeEndtext}</span> <span dangerouslySetInnerHTML={{ __html: content }} style={{color:"#c82e21"}} ></span></h4>
        </>
    );
}
export {Subheading};